<div class="body">
    <div class="col-12 pt-4" *ngIf="formulaire">
        <form [formGroup]="formulaire">
            <div class="card shadow bg-light rounded" style="border-width:2px">
                <div class="card-group shadow">
                    <div class="card shadow bg-light rounded">
                        <h5 class="card-header">Nom et coordonnées de l'association</h5>
                        <fieldset class="card p-3 bg-light">
                            <div class="form-row">
                                <div class="col-md-12">
                                    <bis-textarea-input [rootForm]="formulaire" label="xxAssoNom" [enLectureSeule]="true"
                                        longueurMax=128 longueurRow="2">
                                    </bis-textarea-input>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <bis-string-input [rootForm]="formulaire" label="xxAssoAdr" [enLectureSeule]="true"
                                        longueurMax=114>
                                    </bis-string-input>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-4">
                                    <bis-string-input [rootForm]="formulaire" label="xxAssoCp" [enLectureSeule]="true">
                                    </bis-string-input>
                                </div>
                                <div class="col-md-8">
                                    <bis-string-input [rootForm]="formulaire" label="xxAssoVille" [enLectureSeule]="true">
                                    </bis-string-input>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-7 pt-3">
                                    <bis-string-input [rootForm]="formulaire" libelle="vide" label="xxAssoTel"
                                        [enLectureSeule]="true" prefixe="📞">
                                    </bis-string-input>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-10 pt-3">
                                    <bis-string-input [rootForm]="formulaire" label="xxAssoMail" libelle="vide"
                                        [enLectureSeule]="true" prefixe="@">
                                    </bis-string-input>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <div class="card bg-light rounded">
                        <h5 class="card-header">Personne à contacter <br>(pour informations complémentaires)</h5>
                        <div class="card-body">
                            <div class="form-row">
                                <div class="col-md-12">
                                    <bis-string-input-keypad [rootForm]="formulaire" label="xxContactNom" longueurMax="30">
                                    </bis-string-input-keypad>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <bis-string-input-keypad [rootForm]="formulaire" label="xxContactPrenom" longueurMax="30">
                                    </bis-string-input-keypad>
                                </div>
                            </div>
                            <br>
                            <div class="form-row">
                                <div class="col-md-5 ml-n1 mt-n3">
                                    <bis-filtered-select-input-keypad [rootForm]="formulaire" label="xxIndicTel"
                                        nomNomenclature="indicTel" libelle="📞(Ind outre-Mer)" classeColLabel="col-4" 
                                        classeColInput="col-8">
                                    </bis-filtered-select-input-keypad>
                                </div>
                                <div class="col-md-7 ml-n3 mt-n3">
                                    <span *ngIf="xxIndicTel === '' || xxIndicTel === null">
                                        <bis-phone-mask-input [rootForm]="formulaire" libelle="📞"
                                            [maskFormat]="'00 00 00 00 00'" label="xxContactTel">
                                        </bis-phone-mask-input>
                                    </span>
                                    <span *ngIf="xxIndicTel === '3'">
                                        <bis-phone-mask-input [rootForm]="formulaire" libelle="📞" [maskFormat]="'00 00 00 00'"
                                            label="xxContactTel">
                                        </bis-phone-mask-input>
                                    </span>
                                    <span *ngIf="xxIndicTel === '1' || xxIndicTel === '2'">
                                        <bis-phone-mask-input [rootForm]="formulaire" libelle="📞" [maskFormat]="'00 00 00'"
                                            label="xxContactTel">
                                        </bis-phone-mask-input>
                                    </span>
                                </div>
                            </div>
                            <br>
                            <div class="form-row">
                                <div class="col-md-12">
                                    <bis-email-input [rootForm]="formulaire" label="xxContactMail" libelle="vide"
                                        prefixe="@" longueurMax="100">
                                    </bis-email-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>

            <div style="page-break-before: always"></div>
            
            <h5 class="ml-3 pt-3">DG.1 - Juridictions et BAV dans lesquels l'association est intervenue durant l'année</h5>
            <div class="card-header text-muted">
                <i>Indiquer les juridictions (TJ-TPI-TPRX) et BAV dans lesquels l'association est intervenue durant l'année, en cliquant sur "Ajouter" 
                    et sélectionner le nom/commune pour chaque juridiction et chaque BAV concerné(s)
                </i>
            </div>
            <div class="card-group shadow">
                <div class="card shadow bg-light rounded">
                    <div class="card-header"><i>Liste de(s) TJ/TPI/TPRX</i></div>
                    <div class="card-body">
                        <!-- Appel du composant fille qui gere la boucle -->
                        <bis-juridictions></bis-juridictions>
                    </div>
                </div>
                <div class="card shadow bg-light rounded">
                    <div class="card-header"><i>Liste de(s) BAV</i></div>
                    <div class="card-body">
                        <!-- Appel du composant fille qui gere la boucle -->
                        <bis-liste-bav></bis-liste-bav>
                    </div>
                </div>
            </div>
            <br>

            <h5 class="ml-3 pt-3">DG.2 - Données générales sur les personnes reçues par l'association dans le cadre de l'Aide Aux Victimes</h5>
            <div class="card-header text-muted">
                <i>Indiquer le nombre de personnes reçues dans le cadre de l'aide aux victimes selon qu'elles soient victimes ou non et selon qu'il s'agisse de nouveaux contacts ou non 
                </i>
            </div>
            <fieldset class="ml-2 mr-2 pt-2 pb-3">
                <div class="card rounded bg-light shadow" style="border-width:3px">
                    <div class="form-row">
                        <div class="col-md-12">
                            <table id="table-DG" class="table table-sm m-0 table-bordered">
                                <thead class="thead-light">
                                    <tr>
                                        <th class="text-center align-middle"></th>
                                        <th class="text-center align-middle">Victimes</th>
                                        <th class="text-center align-middle">Personnes concernées par des faits n'ayant<br> pas une qualification pénale</th>
                                        <th class="text-center align-middle"><b> Total</b>
                                            <span *ngIf="modeRendu.enModeSaisie$ | async">
                                                <button class="btn-info mr-2" title="Calcul automatique du total à partir des données ventilées"
                                                    (click)="calculTotalTableauDG1()">
                                                    <b><i>Calcul automatique</i></b>
                                                </button>
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 40%">(1) - Nombre de personnes reçues dans l'année</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxRecuVict" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxRecuNvict" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxRecuTot" classeSupplementaire="integer-input-total text-right" 
                                                [max]="999999" libelle="vide" [erreursCroisees]="['ctrlDg1']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlDg1">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertDg5'></bis-affiche-alertes>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-right align-middle pl-2" style="width: 40%">(2) - <b>Dont</b> pour la première fois dans l'année
                                            <br> (1er contact)</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxPremContactRecuVict" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxPremContactRecuNvict" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxPremContactRecuTot" classeSupplementaire="integer-input-total text-right" 
                                                [max]="999999" libelle="vide" [erreursCroisees]="['ctrlDg2', 'ctrlDg6']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlDg2">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlDg6">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertDg6'></bis-affiche-alertes>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 40%">(3) - Nombre de personnes ayant eu un 1er contact dans l'année non suivi d'un entretien dans l'année</td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxPremContactNrecuVict" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxPremContactNrecuNvict" classeSupplementaire="text-right" [max]="99999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxPremContactNrecuTot" classeSupplementaire="integer-input-total text-right" 
                                                [max]="999999" libelle="vide" [erreursCroisees]="['ctrlDg3']">
                                            </bis-integer-input-keypad>
                                            <bis-affiche-erreurs-croisees colorErreur="danger" [rootForm]="formulaire"
                                                labelErreur="ctrlDg3">
                                            </bis-affiche-erreurs-croisees>
                                            <bis-affiche-alertes labelAlerte='alertDg7'></bis-affiche-alertes>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 40%"><b>Total des premiers contacts de l'année (2+3)</b></td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxPremContactVictTot" [enLectureSeule]="true" classeSupplementaire="integer-input-total text-right" [max]="999999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxPremContactNvictTot" [enLectureSeule]="true" classeSupplementaire="integer-input-total text-right" [max]="999999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxPremContactTot" [enLectureSeule]="true" classeSupplementaire="integer-input-total text-right" [max]="999999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-left align-middle pl-2" style="width: 40%"><b>Total des personnes ayant eu un contact avec l'AAV dans l'année (1+3)</b></td>    
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxContactVictTot" [enLectureSeule]="true" classeSupplementaire="integer-input-total text-right" [max]="999999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxContactNvictTot" [enLectureSeule]="true" classeSupplementaire="integer-input-total text-right" [max]="999999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                        <td class="text-center align-middle pt-3" style="width: 20%">
                                            <bis-integer-input-keypad [rootForm]="formulaire" label="xxContactTot" [enLectureSeule]="true" classeSupplementaire="integer-input-total text-right" [max]="999999" libelle="vide">
                                            </bis-integer-input-keypad>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</div>